<div class="row">
  <div class="col-12">
    <h2 id="propertiesTransferred">Propriétés transférées</h2>

    @for (propertyForm of this.propertyTransferred.formGroups; track propertyForm; let i = $index) {
      <div class="card">
        <div class="row card-body">
          <div class="row d-flex justify-content-between">
            <div class="d-flex" style="width: fit-content">
              <h3 [id]="'transferred-property-' + (i+1)">Propriété transférée #{{ i + 1 }}</h3>
            </div>
            <div class="dropdown d-flex" style="width: fit-content">
              <a aria-haspopup="true" class="dropdown-ellipses dropdown-toggle" data-bs-toggle="dropdown"
                data-expanded="false" href="#" role="button">
                <i class="fe fe-more-vertical"></i>
              </a>
              <div class="dropdown-menu dropdown-menu-end">
                <a (click)="removePropertyTransferred(i); $event.preventDefault()" class="dropdown-item"
                  href="#">
                  Supprimer
                </a>
              </div>
            </div>
          </div>
          <app-rollover-property-form #property [form]="this.form" [index]="i"
          [propertyForm]="propertyForm"></app-rollover-property-form>
        </div>
      </div>
    }

    <div class="card">
      <a (click)="this.addPropertyTransferred(); $event.preventDefault()" class="card-body"
        href="#propertiesTransferred"
        id="add_property_transferred">
        + Ajouter une propriété transférée
      </a>
    </div>

  </div>
</div>